module.exports = __webpack_public_path__ + "img/arrow-left-black.cc871aec.svg";